var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.strength.value
    ? _c("article", [
        _c("table", [
          _c("tr", [
            _c("td", [_vm._v(_vm._s(_vm.$t("Card.Signal.Value")) + ":")]),
            _c("td", [_vm._v(_vm._s(_vm.strength.value) + " dBm")])
          ]),
          _c("tr", [
            _c("td", [
              _vm._v(_vm._s(_vm.$t("Card.Signal.Strength.Status")) + ":")
            ]),
            _c("td", [
              _vm.strength.rangeAcceptableMax < _vm.strength.value
                ? _c(
                    "span",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon icon--error",
                        attrs: { icon: ["fas", "exclamation-circle"] }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Card.Signal.Strength.TooClose")) +
                          " "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.strength.rangeAcceptableMax >= _vm.strength.value &&
              _vm.strength.value >= _vm.strength.rangeAcceptableMin
                ? _c(
                    "span",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon icon--valid",
                        attrs: { icon: ["fas", "check-circle"] }
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("Card.Signal.Strength.Valid")) + " "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.strength.value < _vm.strength.rangeAcceptableMin
                ? _c(
                    "span",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon icon--error",
                        attrs: { icon: ["fas", "exclamation-circle"] }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Card.Signal.Strength.TooFar")) +
                          " "
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ])
      ])
    : _c("p", [_vm._v(_vm._s(_vm.$t("Card.Signal.NoValue")))])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }